import React, { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Do I have to pay customs or import duties?',
      answer: 'No. We maintain stock in both Karachi and Kampala.\n\nFor Pakistan Orders: Stock is already cleared and duty-paid, so no duties are added. Delivery within Karachi is included; freight to other cities is charged separately.\n\nFor Uganda Orders: Direct farm pricing applies.\n\nNo hidden fees, no customs paperwork, no delays.'
    },
    {
      question: 'Is this coffee Halal?',
      answer: 'Yes. It is pure Robusta with no additives or processing agents, so it is suitable for Halal consumption.'
    },
    {
      question: 'How do I place an order?',
      answer: 'We process orders personally. Please click the WhatsApp button or contact us to request your order. We will confirm the final total based on your shipping location.'
    },
    {
      question: 'What are the payment options?',
      answer: 'We accept Cash on Delivery (COD) and Bank Transfer.'
    },
    {
      question: 'How long will delivery take?',
      answer: 'Delivery takes 2-3 days from our Karachi warehouse.'
    },
    {
      question: 'Do you sell whole beans or ground coffee?',
      answer: 'We sell both. You can order roasted whole beans (if you have a grinder) or pre-ground coffee ready for brewing.'
    },
    {
      question: 'What if my package arrives damaged?',
      answer: 'If your package is damaged upon arrival, simply send us a photo. We will ship a replacement free of charge.'
    },
    {
      question: 'Do you sell green beans in bulk?',
      answer: 'Yes. SC-12, SC-15, and SC-18 green Robusta in PKR per kg, duty paid and stocked in Karachi. Volume tiers from 25 kg trial orders up to full container loads, samples on request.',
      link: { href: '/wholesale', label: 'See the wholesale page' }
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 lg:py-28 relative">
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">

          {/* Header and WhatsApp prompt, sticky beside the list on desktop */}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-24">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-clay mb-4">FAQ</p>
              <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-gray-900 mb-6">
                Questions buyers ask
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                Anything else, ask us on WhatsApp. We reply personally and take orders there too.
              </p>
              <a
                href="https://wa.me/447716089293"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-gold-500 hover:bg-gold-400 text-gray-900 px-8 py-4 rounded-full font-bold transition-[background-color,transform] duration-200 active:scale-[0.97]"
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                <span>Chat with Us</span>
              </a>
              <p className="mt-3 text-sm text-gray-600">Cash on delivery available.</p>
            </div>
          </div>

          <ul className="lg:col-span-8 divide-y divide-gray-300/70 border-y border-gray-300/70">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <li key={faq.question}>
                  <button
                    onClick={() => toggleFAQ(index)}
                    className="w-full py-6 flex items-center justify-between gap-6 text-left rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-clay focus-visible:ring-offset-4 focus-visible:ring-offset-oat"
                    aria-expanded={isOpen}
                  >
                    <span className="font-heading text-xl lg:text-2xl text-gray-900">{faq.question}</span>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 16 16"
                      fill="none"
                      aria-hidden="true"
                      className={`flex-shrink-0 text-clay transition-transform duration-300 motion-reduce:transition-none ${isOpen ? 'rotate-180' : ''}`}
                    >
                      <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>

                  {isOpen && (
                    <div className="pb-6 pr-10 animate-fade-in motion-reduce:animate-none">
                      <div className="text-gray-700 leading-relaxed whitespace-pre-line max-w-2xl">
                        {faq.answer}
                      </div>
                      {faq.link && (
                        <a
                          href={faq.link.href}
                          className="mt-3 inline-flex items-center gap-1.5 text-clay font-semibold hover:text-clay/80 transition-colors text-sm"
                        >
                          {faq.link.label}
                          <span aria-hidden="true">&rarr;</span>
                        </a>
                      )}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>

        </div>
      </div>
    </section>
  );
}
